<app-layout>
  <div class="main dashboard-main">
    <div class="header-table">
      <div class="header-title-block">
        <app-titulo>{{ dashboardTitle }}</app-titulo>
        <p class="prototype-banner" *ngIf="prototypeBanner">{{ prototypeBanner }}</p>
      </div>
      <div class="header-buttons">
        <app-botao
          type="secundario"
          class="button"
          text="Gerar PDF"
          icon="assets/download.svg"
          [disabled]="isExportingPdf"
          (click)="gerarPDF()"></app-botao>
      </div>
    </div>

    <div #dashboardPdfContent class="dashboard-pdf-content" [class.exporting-pdf]="isExportingPdf">
      <div class="pdf-report-meta">
        <p class="pdf-report-title">{{ dashboardTitle }}</p>
        <p class="pdf-report-period" *ngIf="form.controls['DT_INIC'].value || form.controls['DT_FIM'].value">
          Período: {{ formatFilterDate(form.controls['DT_INIC'].value) }}
          até {{ formatFilterDate(form.controls['DT_FIM'].value) }}
        </p>
        <p class="pdf-report-generated" *ngIf="pdfGeneratedAt">
          Gerado em {{ pdfGeneratedAt | date: 'dd/MM/yyyy HH:mm' }}
        </p>
      </div>

      <div class="filters-card">
        <form [formGroup]="form" class="table-filters">
          <app-input
            type="datetime-local"
            label="Data Início"
            placeholder="Digite aqui"
            name="DT_INIC"
            formControlName="DT_INIC"
            width="100%"></app-input>
          <app-input
            type="datetime-local"
            label="Data Final"
            placeholder="Digite aqui"
            name="DT_FIM"
            formControlName="DT_FIM"
            width="100%"></app-input>
        </form>
      </div>

      <section class="dashboard-section" *ngIf="temIndicadores()">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('kpis')">
          <span>Indicadores principais</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('kpis')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('kpis')">
          <div class="kpi-grid">
            <div class="kpi-card" *ngFor="let kpi of kpisVisiveis()">
              <span class="kpi-label">{{ kpi.label }}</span>
              <span class="kpi-value">{{ kpi.value }}</span>
              <span class="kpi-hint" *ngIf="kpi.hint">{{ kpi.hint }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="temGraficosOperacionais()">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('charts')">
          <span>Gráficos operacionais</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('charts')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('charts')">
          <div class="charts-grid">
            <section class="chart-card" *ngIf="podeVerGrafico('graficoLimpezasPorMes')">
              <h3>Limpezas por mês</h3>
              <div class="bar-chart vertical">
                <div class="bar-item" *ngFor="let item of limpezasPorMes">
                  <div class="bar-track">
                    <div class="bar-fill" [style.height.%]="barHeight(item.value, limpezasPorMes)"></div>
                  </div>
                  <span class="bar-label">{{ item.label }}</span>
                  <span class="bar-value">{{ item.value }}</span>
                </div>
              </div>
            </section>

            <section class="chart-card" *ngIf="podeVerGrafico('graficoLimpezasPorTerminal')">
              <h3>Limpezas por terminal</h3>
              <div class="bar-chart horizontal">
                <div class="h-bar-row" *ngFor="let item of limpezasPorTerminal">
                  <span class="h-bar-label">{{ item.label }}</span>
                  <div class="h-bar-track">
                    <div class="h-bar-fill" [style.width.%]="barHeight(item.value, limpezasPorTerminal)"></div>
                  </div>
                  <span class="h-bar-value">{{ item.value }}</span>
                </div>
              </div>
            </section>

            <section class="chart-card" *ngIf="podeVerGrafico('graficoLimpezasPorTransportadora')">
              <h3>Limpezas por transportadora</h3>
              <div class="bar-chart horizontal">
                <div class="h-bar-row" *ngFor="let item of limpezasPorTransportadora">
                  <span class="h-bar-label">{{ item.label }}</span>
                  <div class="h-bar-track">
                    <div class="h-bar-fill alt" [style.width.%]="barHeight(item.value, limpezasPorTransportadora)"></div>
                  </div>
                  <span class="h-bar-value">{{ item.value }}</span>
                </div>
              </div>
            </section>

            <section class="chart-card" *ngIf="podeVerGrafico('graficoLimpezasAgendadas')">
              <h3>Limpezas agendadas (D / D+1 / D+2)</h3>
              <div class="bar-chart vertical">
                <div class="bar-item" *ngFor="let item of limpezasAgendadasProximosDias">
                  <div class="bar-track">
                    <div class="bar-fill" [style.height.%]="barHeight(item.value, limpezasAgendadasProximosDias)"></div>
                  </div>
                  <span class="bar-label">{{ item.label }}</span>
                  <span class="bar-value">{{ item.value }}</span>
                </div>
              </div>
            </section>

            <section class="chart-card" *ngIf="podeVerGrafico('graficoMediaMensalServico')">
              <h3>Média mensal por serviço</h3>
              <div class="line-chart-wrap">
                <div class="line-chart-interactive">
                  <svg
                    [attr.viewBox]="'0 0 ' + lineChartWidth + ' ' + lineChartHeight"
                    class="line-chart"
                    (mouseleave)="clearLineHover()">
                    <line
                      *ngIf="lineHoverIndex !== null"
                      class="line-guide"
                      [attr.x1]="chartHoverGuideX()"
                      [attr.x2]="chartHoverGuideX()"
                      [attr.y1]="lineChartPadding"
                      [attr.y2]="lineChartHeight - lineChartPadding"></line>

                    <polyline
                      *ngFor="let series of mediaMensalSeries"
                      [attr.points]="lineChartPoints(series.values)"
                      fill="none"
                      [attr.stroke]="series.color"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"></polyline>

                    <ng-container *ngIf="lineHoverIndex !== null">
                      <circle
                        *ngFor="let series of mediaMensalSeries"
                        class="line-point-active"
                        [attr.cx]="pointOnLineChart(lineHoverValue(series), lineHoverIndex!).x"
                        [attr.cy]="pointOnLineChart(lineHoverValue(series), lineHoverIndex!).y"
                        r="4.5"
                        [attr.fill]="series.color"
                        [attr.stroke]="series.color"></circle>
                    </ng-container>

                    <rect
                      *ngFor="let label of mediaMensalLabels; let i = index"
                      class="line-hover-zone"
                      [attr.x]="chartHoverZoneX(i)"
                      y="0"
                      [attr.width]="chartHoverZoneWidth()"
                      [attr.height]="lineChartHeight"
                      (mouseenter)="setLineHover(i)"
                      (mousemove)="setLineHover(i)">
                      <title>{{ label }}</title>
                    </rect>
                  </svg>

                  <div
                    *ngIf="lineHoverIndex !== null"
                    class="line-tooltip"
                    [style.left.%]="chartTooltipLeftPercent()">
                    <strong>{{ mediaMensalLabels[lineHoverIndex] }}</strong>
                    <ul>
                      <li *ngFor="let series of mediaMensalSeries">
                        <i [style.background]="series.color"></i>
                        <span>{{ series.name }}</span>
                        <strong>{{ lineHoverValue(series) }}</strong>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="line-labels">
                  <span *ngFor="let label of mediaMensalLabels">{{ label }}</span>
                </div>
                <div class="line-legend">
                  <span *ngFor="let series of mediaMensalSeries">
                    <i [style.background]="series.color"></i>{{ series.name }}
                  </span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="temGraficosVendas()">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('sales')">
          <span>Vendas por produto</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('sales')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('sales')">
          <div class="charts-grid">
            <section class="chart-card" *ngIf="podeVerGrafico('graficoVendasQtdTipoServico')">
              <h3>Quantidade de vendas por tipo de serviço</h3>
              <div class="bar-chart horizontal" *ngIf="vendasPorProdutoQuantidade.length; else emptyVendas">
                <div class="h-bar-row" *ngFor="let item of vendasPorProdutoQuantidade">
                  <span class="h-bar-label">{{ item.label }}</span>
                  <div class="h-bar-track">
                    <div class="h-bar-fill sales-qty" [style.width.%]="barHeight(item.value, vendasPorProdutoQuantidade)"></div>
                  </div>
                  <span class="h-bar-value">{{ item.value }}</span>
                </div>
              </div>
            </section>

            <section class="chart-card" *ngIf="podeVerGrafico('graficoVendasValorTipoServico')">
              <h3>Valor total de vendas por tipo de serviço</h3>
              <div class="bar-chart horizontal" *ngIf="vendasPorProdutoValor.length; else emptyVendas">
                <div class="h-bar-row" *ngFor="let item of vendasPorProdutoValor">
                  <span class="h-bar-label">{{ item.label }}</span>
                  <div class="h-bar-track">
                    <div class="h-bar-fill sales-value" [style.width.%]="barHeight(item.value, vendasPorProdutoValor)"></div>
                  </div>
                  <span class="h-bar-value">{{ formatCurrency(item.value) }}</span>
                </div>
              </div>
            </section>
          </div>
          <ng-template #emptyVendas>
            <p class="chart-empty">Nenhuma venda no período selecionado.</p>
          </ng-template>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="temGraficosPagamento()">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('payment')">
          <span>Formas de pagamento</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('payment')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('payment')">
          <div class="charts-grid payment-charts-grid">
            <section class="chart-card" *ngIf="podeVerGrafico('graficoDistribuicaoFormaPagamento')">
              <h3>Distribuição por forma de pagamento</h3>
              <div class="pie-layout">
                <div class="pie-chart" [style.background]="pieGradient(formaPagamento)"></div>
                <ul class="pie-legend">
                  <li *ngFor="let slice of formaPagamento">
                    <i [style.background]="slice.color"></i>
                    <span>{{ slice.label }}</span>
                    <strong>{{ pieSlicePercent(slice.value, formaPagamento) }}%</strong>
                  </li>
                </ul>
              </div>
            </section>

            <section class="chart-card" *ngIf="podeVerGrafico('graficoValoresFormaPagamento')">
              <h3>Valores por forma de pagamento</h3>
              <ul class="payment-values-list">
                <li *ngFor="let slice of formaPagamento">
                  <span class="payment-values-label">
                    <i [style.background]="slice.color"></i>
                    {{ slice.label }}
                  </span>
                  <strong>{{ formatCurrency(slice.value) }}</strong>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </section>
    </div>
  </div>

  <app-loader [isLoading]="isLoading || isExportingPdf"></app-loader>
</app-layout>
